import { normalize } from 'normalizr';

import api from '../../api';
import { schema } from '../../schema';
import { addEntities } from '../../actions';
import Logger from '../../../lib/Logger';

// ACTION TYPES

export const TYPES = {
  COGNITO_FORM_LIST_REQUEST: 'COGNITO_FORM/LIST_REQUEST',
  COGNITO_FORM_LIST_SUCCESS: 'COGNITO_FORM/LIST_SUCCESS',
  COGNITO_FORM_LIST_FAILURE: 'COGNITO_FORM/LIST_FAILURE',
};
// ACTION CREATORS

export function cognitoFormListRequest(page, limit, order, filter) {
  Logger.log(
    'debug',
    `[state.cognitoForms.actions] cognitoFormListRequest(${page}, ${limit}, ${order}, %j)`,
    filter
  );
  return {
    type: TYPES.COGNITO_FORM_LIST_REQUEST,
    page: page,
    limit: limit,
    order: order,
    filter: filter,
  };
}

export function cognitoFormListSuccess(data) {
  Logger.log(
    'debug',
    `[state.cognitoForms.actions] cognitoFormListSuccess(%j)`,
    data
  );
  return {
    type: TYPES.COGNITO_FORM_LIST_SUCCESS,
    page: data.page,
    limit: data.limit,
    order: data.order,
    result: data.result,
    total: data.total,
    receivedAt: Date.now(),
  };
}

export function cognitoFormListFailure(error) {
  Logger.log(
    'debug',
    `[state.cognitoForms.actions] cognitoFormListFailure(%j)`,
    error
  );
  return {
    type: TYPES.COGNITO_FORM_LIST_FAILURE,
    error: error,
  };
}

// API THUNK ACTION CREATORS

export function loadCognitoForms(
  parntership_id = null,
  page = 1,
  limit = 10,
  order = null,
  filter = null,
  cb = function () {}
) {
  Logger.log(
    'debug',
    `[state.cognitoForms.actions] loadCognitoForms(${page}, ${limit}, ${order}, %j, ###)`,
    filter
  );

  return async function (dispatch) {
    dispatch(cognitoFormListRequest(page, limit, order, filter));

    // call API
    const response = await api.getCognitoForms(
      parntership_id,
      page,
      limit,
      order,
      filter
    );
    let success = false;

    // get cognito forms list success
    if (200 === response.get('status')) {
      Logger.log(
        'info',
        `Get API cognito forms list success. Page: ${page}, Limit: ${limit}, Order: ${order}.`
      );

      const normalizedEntities = normalize(
        response.getIn(['data', 'cognito_forms']),
        [schema.cognitoForm]
      );
      const data = {
        page: response.getIn(['data', 'page']),
        limit: response.getIn(['data', 'limit']),
        order: order,
        total: response.getIn(['data', 'total']),
        result: normalizedEntities.result,
      };

      dispatch(addEntities(normalizedEntities));
      dispatch(cognitoFormListSuccess(data));
      success = true;
    } else if (1 === page && 204 === response.get('status')) {
      Logger.log(
        'info',
        `Get API cognito forms success [empty]. Page: ${page}, Limit: ${limit}, Order: ${order}.`
      );
      const data = {
        page: page,
        limit: limit,
        order: order,
        total: 0,
        result: [],
      };
      dispatch(cognitoFormListSuccess(data));
      success = true;

      // get cognito forms list failure
    } else {
      Logger.log(
        'info',
        `Get API cognito forms list failure. Page: ${page}, Limit: ${limit}, Order: ${order}.`
      );
      dispatch(cognitoFormListFailure(response.getIn(['data', 'error'])));
    }

    // callback function
    cb(success);
  };
}

Logger.log('silly', `cognitoForms.actions loaded.`);
